'use client'
import { PrismicRichText } from "@prismicio/react";
import { isFilled } from "@prismicio/client";
import { useState, useEffect } from "react";
import CtaSimple from "@/components/CtaSimple";
import CtaWrapper from "@/components/CtaWrapper";
import Breadcrumbs from "@/components/Breadcrumbs/Breadcrumbs";
import Image from "next/image";




/**
 * @typedef {import("@prismicio/client").Content.HeroWithImageSlice} HeroWithImageSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<HeroWithImageSlice>} HeroWithImageProps
 * @type {import("react").FC<HeroWithImageProps>}
 */
const HeroWithImage = ({ slice, context, index }) => {
  const { title, cta, main_image, mobile_image, text, bg_color } = slice.primary;
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const imageUrl = isDesktop
    ? main_image?.url
    : mobile_image?.url;

  const imageAlt = isDesktop
    ? main_image?.alt || "Image principale de la section"
    : mobile_image?.alt || "Image mobile de la section";

  const hasImage = Boolean(imageUrl);

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`relative framing overflow-hidden flex flex-col justify-center
        ${hasImage ? "bg-no-repeat bg-top bg-cover" : `bg-${bg_color}`} ${slice.variation === 'default' ? 'min-h-[85vh] max-h-400 lg:p-24 py-20 items-center' : slice.variation == 'withText' ? 'pb-25' : 'py-20 md:py-30 items-center'}`}
      style={hasImage ? { backgroundImage: `url(${imageUrl})` } : {}}
      aria-label={isFilled.richText(title) ? title[0]?.text : "Section principale"}
      role="region"
    >
      {slice.variation == 'withText' &&  <Breadcrumbs context={context} index={index} textcolor={"text-white"} />}
      <div className={`${slice.variation == 'withText' ? 'pt-10 md:pt-15' : ''} w-full max-w-375 m-auto`}>
        <div className={`${slice.variation === 'default' ? 'max-w-243 ' : 'max-w-300'} flex flex-col m-auto justify-center items-center gap-10 lg:gap-16`}>
          {isFilled.richText(title) && (
            <PrismicRichText
              field={title}
              components={{
                heading1: ({ children }) => (
                  <h1 className="text-center text-white">
                    {children}
                  </h1>
                ),
                heading2: ({ children }) => (
                  <h2 className="text-center text-white text-hero">
                    {children}
                  </h2>
                ),
                heading3: ({ children }) => (
                  <h3 className="text-center text-white text-hero">
                    {children}
                  </h3>
                ),
              }}
            />
          )}
          {Array.isArray(cta) && cta.length > 0 && (
            <CtaWrapper cta={cta} padding={"px-10"} width={"w-full md:w-auto"} />
          )}
        </div>
        {slice.variation == 'withText' && <div className="max-w-280 m-auto mt-6">
          {isFilled.richText(text) && (
            <PrismicRichText
              field={text}
              components={{
                paragraph: ({ children }) => (
                  <p className="text-center text-white p-syne mb-6">
                    {children}
                  </p>
                ),
              }}
            />
          )}
          <div className="flex flex-col items-center gap-11">
            <Image
              src="/yy.svg"
              alt="Logo YY de Yes Yes Padel"
              width={40}
              height={32}
              className="w-10 h-8 object-contain"
              priority
            />
            {isFilled.link(cta) && (
              <CtaSimple page={cta} padding={"px-5"}  width={"w-full md:w-auto"} hover={"white"} />
            )}
          </div>
        </div>
        }
      </div>
      {slice.variation == 'default' && <div className="absolute -bottom-[1px] w-full">
        <Image
          src="/yline-desktop-green.svg"
          alt="Ligne décorative verte desktop Yes Yes Padel"
          width={1920}
          height={100}
          className="hidden md:block w-full h-auto"
          priority
        />
        <Image
          src="/yline-mobile-green.svg"
          alt="Ligne décorative verte mobile Yes Yes Padel"
          width={600}
          height={100}
          className="md:hidden w-full h-auto"
          priority
        />
      </div>
      }
    </section>
  );
};

export default HeroWithImage;
